import React from "react";
import "./styles.scss";
import { RiCloseFill } from "react-icons/all";

const Index = (props) => (
  <>
    <div className={`action-icon-wrapper ${props.size ?? "sm"} ${props.type}`} onClick={props.onClick}>
      {props.icon ?? <RiCloseFill />}
    </div>
  </>
);
export default Index;
